export const COLOR = {
  TURQUOISE: '#51e8fc',
  ULTRA_LIGHT_BLUE: '#ACE1FA',
  LIGHT_BLUE: '#00bdf2',
  LIGHT_BLUE_BG: '#E4F9FF',
  BLUE: '#007DC5',
  BLUE2: '#00BDF2',
  SECONDARY_BLUE: '#1D2F66',
  SYSTEM_BLUE: '#2EA6FB',
  DARK_BLUE: '#034EA2',
  VERY_DARK_BLUE: '#0325a2',
  RED: '#db3236',
  GREEN: '#0FA958',
  ORANGE: '#ff7b0e',
  LIGHT_ORANGE: '#FF9900',
  GREY: '#bcbbc1',
  LIGHT_GREY: '#ebebeb',
  ULTRA_LIGHT_GREY: '#f3f3f3',
  LIGHT_GREY_BG: '#FAFAFC',
  DARK_GREY: '#7f7e82',
  BROWN: '#330000',
  GREEN_DARTMOUTH: '#306B34',
  BLACK: '#000',
  WHITE: '#FFFFFF',
  ULTRA_DARK_BLUE: '#0b1532',
  DELETE_RED: '#fc5249',
  LIGHT_RED: '#fa4d53',
  RED_TEXT: '#FA5B38',
  LIGHT_RED_CONTENT: '#FFECED',
  TRANSPARENT_BLACK: 'rgba(0,0,0,0.2)',
  SOCIAL_MEDIA_GREY: '#5a5a5a',
  LIGHT_YELLOW: '#FFF8E3',
  YELLOW: '#FFBE00',
  DARK_YELLOW: '#FFA000',
  CHARCOAL: '#333333',
  LIGHT_GREEN: '#C9FFD2',
  TRANSPARENT: 'transparent',
  ULTRA_LIGHT_PURPLE: '#F7F8FC',
  SYSTEM_GREY: 'rgba(0, 0, 0, 0.22)',
};

export const COLOR_CONTRAST_RATIO = 4;
export const PAGE_SIZE = 10;
export const GRID_PAGE_SIZE = 18;

export const MIN_VISIT_COUNT = 15;
export const MAX_FILTER_PRICE = 5000000;
export const TEMPLATES = {
  BIG_BANNER: {
    key: 'big_banner',
    url: 'https://siteweb.hausvalet.ca/',
  },
  LISTINGS_BANNER: {
    key: 'listings_banner',
    url: 'https://siteweb.hausvalet.ca/proprietes',
  },
  SIMPLE: {
    key: 'simple',
    url: 'https://siteweb.hausvalet.ca/',
  },
  BROKER_HIGHLIGHT: {
    key: 'broker_highlight',
    url: 'https://siteweb.hausvalet.ca/',
  },
  VIDEO: {
    key: 'video',
    url: '',
  },
};
export const HAUSVALET_IP_ADDRESS = '34.47.12.183';
export const CLIENT_PAGE_EXAMPLE_LINK =
  'https://siteweb.hausvalet.ca/client-presentation/04610f8f-d766-4d25-9335-80caae3e60a9';
export const MODAL = {
  SHOOTING_EDIT: 'SHOOTING_EDIT',
  SHOOTING_CANCEL: 'SHOOTING_CANCEL',
  DRAFT_SHOOTING_DELETE: 'DRAFT_SHOOTING_DELETE',
  DRAFT_SHOOTING_SAVE: 'DRAFT_SHOOTING_SAVE',
  SUCCESS: 'SUCCESS',
  TRANSER_REQUEST: 'TRANSER_REQUEST',
  AUTO_UPLOAD: 'AUTO_UPLOAD',
  LOGIN: 'LOGIN',
  VIRTUAL_STAGING: 'VIRTUAL_STAGING',
  VIRTUAL_STAGING_SECOND_STEP: 'VIRTUAL_STAGING_SECOND_STEP',
  VIRTUAL_STAGING_REVIEW: 'VIRTUAL_STAGING_REVIEW',
  FLOORPLAN: 'FLOORPLAN',
  ADDITIONAL_PICTURES: 'ADDITIONAL_PICTURES',
  PICTURE_SWAP: 'PICTURE_SWAP',
  RECOMMENDATION: 'RECOMMENDATION',
  ADD_NEW_FAVORITE_LISTING: 'ADD_NEW_FAVORITE_LISTING',
  REMOVE_FAVORITE_LISTING: 'REMOVE_FAVORITE_LISTING',
  SHARE: 'SHARE',
  SLIDESHOW: 'SLIDESHOW',
  SLIDESHOW_TEMPLATE: 'SLIDESHOW_TEMPLATE',
  SLIDESHOW_REVIEW: 'SLIDESHOW_REVIEW',
  AI_SERVICES: 'AI_SERVICES',
  GENERATED_PHOTOS: 'GENERATED_PHOTOS',
  SCHEDULER_MODAL: 'SCHEDULER_MODAL',
  SECTION_TEMPLATE: 'SECTION_TEMPLATE',
  EDIT_TESTIMONIALS: 'EDIT_TESTIMONIALS',
  DEMO_TEMPLATE: 'DEMO_TEMPLATE',
  ABOUT_TEMPLATE: 'ABOUT_TEMPLATE',
  ORDER_SERVICE_OFFER: 'ORDER_SERVICE_OFFER',
  CHANGE_FLOOR_TYPE: 'CHANGE_FLOOR_TYPE',
};
export const SERVICEMODALSTEP = {
  EXAMPLE: 0,
  OPTION: 1,
  REVIEW: 2,
  BLUEHOUR: 3,
  SUMMARY: 4,
};
export const FLOORPLANMODALSTEP = {
  EXAMPLE: 0,
  OPTION: 1,
  REVIEW: 2,
};
export const PICTURESWAPSTEP = {
  EXCHANGE: 0,
  EXCHANGEWITH: 1,
  CONFIRM: 2,
};
export const ADD_NEW_FAVORITE_LISTING_STEP = {
  OPTIONS: 0,
  SEARCH_LISTING: 1,
  DEMO_LISTINGS: 2,
  CONFIRM: 3,
};
export const SERVICE_OFFER_NAME = {
  VIRTUAL_BLUE_HOUR: 'Virtual Blue Hour',
  VIRTUAL_RENOVATION: 'Virtual Renovation',
};
export const VIRTUAL_SERVICE_OFFER_TYPE = {
  VIRTUAL_BLUE_HOUR: 'virtualBlueHour',
};
export const SIDEBAR = {
  SHOOTING_DETAIL: 'SHOOTING_DETAIL',
};

export const ALERT = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
};

export const SLIDESHOW_USERS = [2533];

export const PLACE_OPTION_TYPES = {
  GOOGLE: 'GOOGLE',
  POST_CANADA: 'POST_CANADA',
  EXPAND_SEARCH: 'EXPAND_SEARCH',
};

export const DATEFORMAT_MY = 'MM/yyyy';

export const SHOOTING_STEPS = {
  LOCATION: 0,
  PROPERTY: 1,
  PACKAGE: 2,
  SERVICE: 3,
  CLIENT_INFO: 4,
  REVIEW: 5,
  SELECT_DATETIME: 6,
};

export const PLANS = {
  FREE: 0,
  MONTHLY: 1,
  YEARLY: 2,
  TERM: {
    MONTHLY: 0,
    QUARTERLY: 1,
    YEARLY: 2,
  },
  SUBSCRIPTION_PORTAL_LINK: 'https://subscriptions.zoho.com/portal/hausvalet',
};

export const GPT = {
  TEXT_LENGTH: {
    SHORT: 'short',
    MEDIUM: 'medium',
    LONG: 'long',
  },
  MAX_INPUT_LENGTH: 100, // 100 Characters
  MAX_PROMPT_TAGS_CHARACTERS: 1400, // 1400 Characters (about 400 tokens)
  DAILY_TOKEN_LIMIT: 10000, // 10000 Tokens
};

export const TEXTINPUT_TYPE = {
  TEXT: 0,
  DROPDOWN: 1,
  NUMBER: 2,
};

export const PROFILE_ITEMS = {
  MOBILE: 'phone_number',
  OFFICE: 'office_phone_number',
  TITLE: 'title_num',
  CUSTOM_TITLE: 'custom_title',
  BANNER_ID: 'banner_id',
  FRANCHISE_ID: 'franchise_id',
  CENTRIS_CODE: 'broker_code',
  AUTOMATIC_SAISIE: 'automatic_saisie',
  QACIQ_CODE: 'oaciq_code',
  FBPIXEL_ID: 'pixel_id',
  PASSWORD: 'password',
};
export const USER_ROLE = {
  SUPERADMIN: 1,
  ADMIN: 2,
  BROKER: 3,
};

export const CENTRIS_UPLOAD_SERVICE_OFFER_IDS = [33, 85, 95, 237];

export const VIRTUAL_SERVICES = {
  FURNITURE_WEBSITE: 'https://www.virtualfurniture.io/?c=ge3wZqDn5X',
  CONTACT_LINK: 'https://hausvalet.ca/contact/',
};

export const GOOGLE_MAP = {
  GOOGLE_MAP_URL:
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCBlV8_octv2fJn5m6dAPJPn0UozRFm_q8&v=3.exp',
  DEFAULT_GOOGLE_MARKER_ICON: 'http://maps.google.com/mapfiles/ms/micons/man.png',
  SHOOTING_MARKER_ICON:
    'https://storage.googleapis.com/cdn.hauslifenetwork.com/logo/HausValet%20_fav.png',
};

export const ADMIN_PANEL_URL = 'https://admin.hausvalet.ca';

export const INVOICE_URL_PREFIX = 'https://books.zoho.com/app#/invoices/';

export const GST_QST_RATE = 0.14975;

export const PORTAL_CUSTOM_SECTIONS_TEMPLATES = {
  BLOCK: 'block',
  LIST: 'list',
  SIMPLE: 'simple',
};
export const PORTAL_CUSTOM_SECTIONS_STYLE = {
  TITLE_FONT_WEIGHT: 'titleFontWeight',
  TITLE_COLOR: 'titleColor',
  BACKGROUND_COLOR: 'backgroundColor',
  CARD_TITLE_COLOR: 'cardTitleColor',
  CARD_BACKGROUND_COLOR: 'cardBackgroundColor',
  CONTENT_TEXT_COLOR: 'contentTextColor',
  BOLD: 'bold',
  REGULAR: 'regular',
  BOLD_FONT: 'FordAntenna-Bold',
  REGULAR_FONT: 'FordAntenna-Regular',
};

export const PORTAL_SECTIONS = {
  BASIC_INFO: {
    key: 'basic_info',
    subSections: {
      PERSONAL_INFO: {
        key: 'personal_info',
      },
      SOCIAL_MEDIA: {
        key: 'social_media',
      },
      IMAGES: {
        key: 'images',
      },
      THEME: {
        key: 'theme',
        colors: ['primary_color', 'secondary_color', 'header_bg_color'],
      },
    },
  },
  PROPERTY: {
    key: 'properties',
    key_fr: 'proprietes',
    subSections: [],
  },
  CENTRIS_LISTINGS: {
    key: 'listing',
    subSections: [],
  },
  CONTACT: {
    key: 'contact',
    subSections: [],
  },
};
export const PORTAL_CUSTOM_SECTIONS = {
  // TODO: Add more sections
  ABOUT: {
    key: 'about',
    key_fr: 'apropos',
    components: {
      content: 'about',
    },
    hasMultipleTemplates: true,
    hasMultipleSubContents: false,
    defaultValue: {
      key: 'about',
      value_en: '',
      value_fr: '',
    },
  },
  HOBBY: {
    key: 'hobby',
    key_fr: 'loisir',
    components: {
      content: 'hobby',
    },
    hasMultipleTemplates: false,
    hasMultipleSubContents: true,
    defaultValue: {
      key: 'hobby',
      subtitle_en: '',
      subtitle_fr: '',
      description_en: '',
      description_fr: '',
    },
  },
  VIDEO: {
    key: 'video',
    key_fr: 'video',
    components: {
      content: 'video',
    },
    hasMultipleTemplates: false,
    hasMultipleSubContents: false,
    defaultValue: {
      key: 'video',
      value_en: '',
      value_fr: '',
    },
  },
  AWARDS: {
    key: 'awards',
    key_fr: 'prix',
    components: {
      content: 'awards',
    },
    hasMultipleTemplates: false,
    hasMultipleSubContents: true,
    defaultValue: {
      key: 'awards',
      subtitle_en: '',
      subtitle_fr: '',
    },
  },
  BUYERS: {
    key: 'buyers',
    key_fr: 'acheteurs',
    components: {
      content: 'buyers',
    },
    hasMultipleTemplates: false,
    hasMultipleSubContents: true,
    defaultValue: {
      key: 'buyers',
      subtitle_en: '',
      subtitle_fr: '',
      description_en: '',
      description_fr: '',
    },
  },
  SELLERS: {
    key: 'sellers',
    key_fr: 'vendeurs',
    components: {
      content: 'sellers',
    },
    hasMultipleTemplates: false,
    hasMultipleSubContents: true,
    defaultValue: {
      key: 'sellers',
      subtitle_en: '',
      subtitle_fr: '',
      description_en: '',
      description_fr: '',
    },
  },
  SERVICES: {
    key: 'services',
    key_fr: 'services',
    comopnents: {
      content: 'services',
    },
    hasMultipleTemplates: false,
    hasMultipleSubContents: false,
    defaultValue: {
      key: 'services',
      value: [],
    },
  },
  TESTIMONIAL: {
    key: 'testimonial',
    key_fr: 'temoignage',
    components: {
      content: 'testimonials',
    },
    hasMultipleTemplates: true,
    hasMultipleSubContents: true,
    defaultValue: {
      key: 'testimonial',
      name_en: '',
      name_fr: '',
      description_en: '',
      description_fr: '',
    },
  },
};
export const TABS_KEYS = [
  PORTAL_CUSTOM_SECTIONS.BUYERS.key,
  PORTAL_CUSTOM_SECTIONS.SELLERS.key,
  PORTAL_CUSTOM_SECTIONS.TESTIMONIAL.key,
];

export const HAUSVALET_ADMIN_PORTAL = 'hausportal.hausvalet.ca';

export const BROKER_PORTAL_SUBSCRIPTION = {
  WITHOUT_LISTING: 1,
  WITH_LISTINGS: 2,
};

export const BROKER_PORTAL_DEMO_LINKS = {
  DEMO_PORTAL_LINK: '',
  DEMO_CLIENT_PAGE_LINK: '',
};

export const REALTOR_WEBSITE_COLORS = [
  {
    key: 'century21',
    title: 'Century 21',
    primary_color: COLOR.WHITE,
    secondary_color: '#BEAF87',
    header_bg_color: '#252526',
  },
  {
    key: 'engelvolkers',
    title: 'Engel & Völkers',
    primary_color: COLOR.WHITE,
    secondary_color: '#E60000',
    header_bg_color: COLOR.WHITE,
  },
  {
    key: 'exprealty',
    title: 'eXp Realty',
    primary_color: COLOR.WHITE,
    secondary_color: '#314482',
    header_bg_color: '#0E0F19',
  },
  {
    key: 'propriodirect',
    title: 'Proprio Direct',
    primary_color: COLOR.WHITE,
    secondary_color: '#D0103A',
    header_bg_color: '#F9F9F9',
  },
  {
    key: 'remax',
    title: 'RE/MAX',
    primary_color: COLOR.WHITE,
    secondary_color: '#DC1C2E',
    header_bg_color: '#1F355E',
  },
  {
    key: 'royallepage',
    title: 'Royal LePage',
    primary_color: COLOR.WHITE,
    secondary_color: '#EA002A',
    header_bg_color: COLOR.WHITE,
  },
  {
    key: 'sothebys',
    title: "Sothby's",
    primary_color: COLOR.WHITE,
    secondary_color: '#F89609',
    header_bg_color: '#001731',
  },
  {
    key: 'sutton',
    title: 'Sutton',
    primary_color: COLOR.WHITE,
    secondary_color: '#CF112B',
    header_bg_color: '#111111',
  },
  {
    key: 'viacapital',
    title: 'viacapital',
    primary_color: COLOR.WHITE,
    secondary_color: '#11ABD6',
    header_bg_color: '#333333',
  },
];

export const LISTING_EXAMPLE_PHOTOS = [
  {
    url: 'https://cdn.hauslifenetwork.com/12564/2D/12564_13909_100_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/12564/2D/12564_13909_100_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/12845/2D/12845_14231_104_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/12845/2D/12845_14231_104_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5235/2D/5235_5405_71_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5235/2D/5235_5405_71_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/8559/2D/8559_9324_105_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/8559/2D/8559_9324_105_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/8559/2D/8559_9324_107_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/8559/2D/8559_9324_107_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/8966/2D/8966_9804_108_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/8966/2D/8966_9804_108_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/19746/2D/19746_22582_14_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/19746/2D/19746_22582_14_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/20726/2D/20726_23715_377_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/20726/2D/20726_23715_377_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/8966/2D/8966_9804_601_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/8966/2D/8966_9804_601_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5248/2D/5248_5419_19_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5248/2D/5248_5419_19_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5235/2D/5235_5405_138_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5235/2D/5235_5405_138_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5354/2D/5354_5549_31_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5354/2D/5354_5549_31_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/6654/2D/6654_7111_1_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/6654/2D/6654_7111_1_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5289/2D/5289_5468_60_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5289/2D/5289_5468_60_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5289/2D/5289_5468_49_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5289/2D/5289_5468_49_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5289/2D/5289_5468_17_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5289/2D/5289_5468_17_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5248/2D/5248_5419_19_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5248/2D/5248_5419_19_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5035/2D/5035_5164_73_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5035/2D/5035_5164_73_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5147/2D/5147_5301_19_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5147/2D/5147_5301_19_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/5235/2D/5235_5405_123_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/5235/2D/5235_5405_123_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/8966/2D/8966_9804_129_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/8966/2D/8966_9804_129_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/11459/2D/11459_12638_201_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/11459/2D/11459_12638_201_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/11459/2D/11459_12641_23_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/11459/2D/11459_12641_23_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/11946/2D/11946_13192_101_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/11946/2D/11946_13192_101_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/11946/2D/11946_13192_106_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/11946/2D/11946_13192_106_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/11946/2D/11946_13192_117_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/11946/2D/11946_13192_117_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/12041/2D/12041_13305_200_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/12041/2D/12041_13305_200_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/12564/2D/12564_13909_154_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/12564/2D/12564_13909_154_thumb.jpg',
  },
  {
    url: 'https://cdn.hauslifenetwork.com/6731/2D/6731_8503_48_web.jpg',
    thumbnail: 'https://cdn.hauslifenetwork.com/6731/2D/6731_8503_48_thumb.jpg',
  },
];

export const FAKE_ROOM = {
  roomname: 'Facade',
  height: 10,
  height_inches: 0,
  width: 40,
  width_inches: 0,
  irregular: false,
  floor: 0,
  floor_type: null,
  metadata: [],
  marker: null,
};

export const VIRTUAL_TOUR_EXAMPLES = [
  {
    link: 'https://visite.hausvalet.ca/visit/5235',
    image: 'https://hausvalet.ca/wp-content/uploads/2021/02/5235-e1629981162340.png',
  },
  {
    link: 'https://visite.hausvalet.ca/visit/4888',
    image: 'https://hausvalet.ca/wp-content/uploads/2021/02/4888-e1629981173204.png',
  },
];
